import React, { useEffect, useState } from 'react';
import { useSnackbar } from 'material-ui-snackbar-provider';

import styles from './FinishPreviewModal.module.scss';
import { User } from '../../../../components/modules/OrganizationCard';
import { ContainedButton, OutlinedButton } from '../../../../components/modules/Buttons';
import Modal from '../../../../components/modules/Modal';
import { TextField } from '@mui/material';

type TDeleteUserModalProps = {
  isOpen: boolean;
  switchModal: () => void;
  resolveCallback: (text: string) => void;
  rejectCallback: (text: string) => void;
};

const FinishPreviewModal: React.FC<TDeleteUserModalProps> = ({ isOpen, switchModal, resolveCallback, rejectCallback }) => {
  const [loading, setLoading] = useState(false);
  const [response, setResponseText] = useState('');
  const notification = useSnackbar();
  const onClose = () => {
    switchModal();
    setLoading(false);
  };

  const handleResolved = async () => {
    try {
      setLoading(true);
      resolveCallback(response);
    } catch (err) {
      // @ts-ignore
      if (err?.response?.data?.message) {
        // @ts-ignore
        notification.showMessage(err.response.data.message);
      } else {
        console.log(err);
      }
    } finally {
      setLoading(false);
      onClose();
    }
  };

  const handleRejected = async () => {
    try {
      setLoading(true);
      rejectCallback(response);
    } catch (err) {
      // @ts-ignore
      if (err?.response?.data?.message) {
        // @ts-ignore
        notification.showMessage(err.response.data.message);
      } else {
        console.log(err);
      }
    } finally {
      setLoading(false);
      onClose();
    }
  };

  const onResponseTextChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => setResponseText(e.target.value);

  useEffect(() => {
    console.log('isOpen: ', isOpen);
  }, [isOpen]);

  return (
    <Modal open={isOpen} loading={loading}>
      <div className={styles.modalBody}>
        <div className={styles.modalTitle}>Super Admin’s Review</div>

        <div className={styles.form}>
          <div className={styles.descriptionLabel}>Here you can text us on what is the problem:</div>
          <div className={styles.descriptionBg}>
            <textarea
              onChange={onResponseTextChange}
              className={styles.descriptionField}
              placeholder="Type your answer here..."
              style={{ resize: 'vertical', overflow: 'hidden' }}
              id="description"
              cols={33}
            />
          </div>
          <div className={styles.actionBtns}>
            <ContainedButton className={styles.resolveButton} disabled={loading} onClick={handleResolved}>
              <span>Issue Resolved</span>
            </ContainedButton>

            <OutlinedButton className={styles.rejectButton} disabled={loading} kind="default" onClick={handleRejected}>
              <span>Issue wasn't resolved</span>
            </OutlinedButton>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default FinishPreviewModal;
